module.exports = __webpack_public_path__ + "static/media/fishes-on-wall-2.a5b93b48.png";